<template>
  <div class="input-button">
    <button
      class="child"
      @click.stop="model"
      :style="{
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        color: color
      }"
    >
      <span>{{ text }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'input-button',
  props: {
    text: {
      default: 'Button',
      type: String
    },
    model: {
      default: () => ({}),
      type: Function
    },
    backgroundColor: {
      default: '#000bff',
      type: String
    },
    color: {
      default: '#ffffff',
      type: String
    },
    width: {
      default: '150px',
      type: String
    },
    height: {
      default: '50px',
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.input-button {
  position: relative;
  width: 100%;
  height: 50px;
  .child {
    cursor: pointer;
    width: inherit;
    height: inherit;
    border-radius: 2px;
    background-color: #000bff;
    border: 0;

    span {
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1px;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
